<template>
  <div class="table promocode-table">
    <div class="table__header">
      <TableHeaderCell v-for="(tHeader, idx) in tableHeaders" :key="idx" :tHeader="tHeader" :index="idx" />
    </div>
    <div class="table__loading" v-if="loading"><Loader/></div>
    <div class="table__body" :class="{ 'table__body--loading': loading}" v-if="promocodeList && promocodeList.length">
      <TableBodyRow
        v-for="(promocode, idx) in promocodeList"
        :key="idx"
        :promocode="promocode"
        @edit="$emit('edit', promocode)"
        @delete="$emit('delete', promocode)"
      />
    </div>
    <EmptyBlock v-else-if="!loading" />
  </div>
</template>


<script>
  import Loader from '@/components/Loader.vue'
  import EmptyBlock from '@/components/Empty.vue'
  import tableHeaders from '@/data/PromocodeListTabs'
  import TableHeaderCell from '@/components/PromocodeTable/TableHeaderCell.vue'
  import TableBodyRow from '@/components/PromocodeTable/TableBodyRow.vue'

  export default {
    components: {
      EmptyBlock,
      TableHeaderCell,
      TableBodyRow,
      Loader,
    },
    props: {
      promocodeList: {
        type: Array,
        require: true
      },
      loading: {
        type: Boolean,
        require: true
      }
    },
    computed: {
      tableHeaders() {
        return tableHeaders
      }
    },
  }
</script>

<style lang="scss" scoped>
  .promocode-table {
    .table__loading {
      position: absolute;
      bottom: 0;
    }

    .table__body--loading {
      filter: opacity(0.3);
    }

    .table__header {
      display: flex;
      border-radius: 1rem;
      padding: 1rem 0;
    }

    .table__body {
      display: flex;
      flex-direction: column;
    }

    .table__th {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.8rem 0.6rem;

      &:nth-of-type(1) { flex: 0 0 10rem; }
      &:nth-of-type(2) { flex: 0 0 14rem; }
      &:nth-of-type(3) { flex: 0 0 8rem; }
      &:nth-of-type(4) { flex: 0 0 8rem; }
      &:nth-of-type(5) { flex: 0 0 8rem; }
      &:nth-of-type(6) { flex: 0 0 8rem; }
      &:nth-of-type(7) { flex: 0 0 8rem; }
      &:last-child { flex: 0 0 8rem; }

      &:first-child {
        .table__th-inner {
          justify-content: flex-start;
        }
      }
    }
  }
</style>
